export class StringHelper {
    static camelCaseToSpaces(string: string) {
        return string ? string.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1') : ''
    }

    static returnDotDotDotIfMoreThan(text: string, length: number = 150) {
        var notifMessage = text
        if (notifMessage && notifMessage.length > length) {
            notifMessage = notifMessage.substring(0, length) + ' ...'
        }
        return notifMessage
    }
}
